(function () {
  const POLL_INTERVAL = 50;
  const POLL_TIMEOUT = 15000;

  const MULTI_TEMPLATE =
    '<div class="bold_option bold_option_{{ optionType }}">\n\t{{#optionTitle}}\n\t\t<span class="bold_option_title">{{{ optionTitle }}}</span>\n\t{{/optionTitle}}\n\t\n\t{{#toolTip}}<span class="bold_tooltip"><small>{{{ toolTip }}}</small></span>{{/toolTip}}\n\t\n\t<span class="bold_option_element">\n\t\t{{#optionElement}}\n\t\t\t<span class="bold_option_value {{#optionValueNoStock}}bold_option_out_of_stock{{/optionValueNoStock}}">\n\t\t\t\t<label>\n\t\t\t\t\t{{#optionValueElement}}\n\t\t\t\t\t\t{{{ optionValueElement }}}\n\t\t\t\t\t{{/optionValueElement}}\n\t\t\t\t\t\n\t\t\t\t\t{{#optionValueTitle}}\n\t\t\t\t\t\t<span class="bold_option_value_title">{{{ optionValueTitle }}}</span>\n\t\t\t\t\t{{/optionValueTitle}}\n\n\t\t\t\t\t{{#optionValuePrice}}\n\t\t\t\t\t\t<span class="bold_option_value_price">{{{ optionValuePrice }}}</span>\n\t\t\t\t\t{{/optionValuePrice}}\n\t\t\t\t</label>\n\t\t\t\t\n\t\t\t\t{{#optionValueQuantity}}\n\t\t\t\t\t<span class="bold_option_value_quantity">{{{ optionValueQuantity }}}</span>\n\t\t\t\t{{/optionValueQuantity}}\n\t\t\t\t\n\t\t\t\t{{#optionValueNoStock}}\n\t\t\t\t\t<span class="bold_out_of_stock_message">\n\t\t\t\t\t\t<small>{{ outOfStockMessage }}</small>\n\t\t\t\t\t</span>\n\t\t\t\t{{/optionValueNoStock}}\n\t\t\t</span>\n\t\t{{/optionElement}}\n\t</span>\n\t\n\t{{#helpText}}<span class="bold_help_text"><small>{{{ helpText }}}</small></span>{{/helpText}}\n</div>';

  const CHECKBOX_TEMPLATE =
    '<div class="bold_option bold_option_{{ optionType }} {{#optionValueNoStock}}bold_option_out_of_stock{{/optionValueNoStock}}">\n\t<label>\n\t\t{{#optionElement}}\n\t\t\t{{{ optionElement }}}\n\t\t{{/optionElement}}\n\t\n\t\t{{#optionTitle}}\n\t\t\t<span class="bold_option_title">{{{ optionTitle }}}</span>\n\t\t{{/optionTitle}}\n\t\t\n\t\t{{#optionValuePrice}}\n\t\t\t<span class="bold_option_value_price">{{{ optionValuePrice }}}</span>\n\t\t{{/optionValuePrice}}\n\t</label>\n\t\n\t{{#optionQuantity}}\n\t\t<span class="bold_option_value_quantity">{{{ optionQuantity }}}</span>\n\t{{/optionQuantity}}\n\t\n\t{{#optionValueNoStock}}\n\t\t<span class="bold_out_of_stock_message">\n\t\t\t<small>{{ outOfStockMessage }}</small>\n\t\t</span>\n\t{{/optionValueNoStock}}\n\t\n\t{{#toolTip}}<span class="bold_tooltip"><small>{{{ toolTip }}}</small></span>{{/toolTip}}\n\t{{#helpText}}<span class="bold_help_text"><small>{{{ helpText }}}</small></span>{{/helpText}}\n</div>';

  function applyTemplates(options) {
    options.templates = options.templates || {};
    options.setTemplate('multi', MULTI_TEMPLATE);
    options.setTemplate('checkbox', CHECKBOX_TEMPLATE);
  }

  function bindOptionChanged(options) {
    options.app.on('option_changed', ({ data: { option, value } }) => {
      const option_set_pattern = option.internalName.match(/(swatches_limit_)([0-9]+)/);

      if (!option_set_pattern) return;

      try {
        const limit = option_set_pattern[2];
        const count = value.length;
        const max = count == limit;
        const checkboxes = document.querySelectorAll(`input[type="checkbox"].${option.className}:not(:checked)`);

        document.querySelector('button.add-to-cart-button.bold_clone').disabled = value && value.length < 1;

        if (count + 2 <= limit) return;

        [...checkboxes].map((checkbox) => {
          checkbox.disabled = max;
          max ? checkbox.parentNode.classList.add('disabled') : checkbox.parentNode.classList.remove('disabled');
        });
      } catch {
        console.warn(`Bold swatches: Could not detect a limit in ${option.className}`);
      }
    });
  }

  function isBoldReady() {
    const options = window.BOLD && window.BOLD.options;

    return Boolean(
      options && typeof options.setTemplate === 'function' && options.app && typeof options.app.on === 'function'
    );
  }

  const startedAt = Date.now();

  (function waitForBold() {
    if (isBoldReady()) {
      const options = window.BOLD.options;

      try {
        applyTemplates(options);
        bindOptionChanged(options);
      } catch (error) {
        console.warn('Bold options customizations failed to initialize:', error);
      }

      return;
    }

    if (Date.now() - startedAt < POLL_TIMEOUT) setTimeout(waitForBold, POLL_INTERVAL);
  })();

  function updateBoldOptionTitles(scope = document) {
    scope.querySelectorAll('label').forEach((label) => {
      const input = label.querySelector('.bold_option_value_element input');
      const title = label.querySelector('.bold_option_value_title');

      if (!input || !title) return;

      title.classList.toggle('is-selected', input.checked);
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target instanceof Element && event.target.matches('.bold_option_value_element input')) {
      updateBoldOptionTitles(document);
    }
  });

  function observeBoldOptions() {
    updateBoldOptionTitles(document);

    let scheduled = false;

    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        updateBoldOptionTitles(document);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeBoldOptions);
  } else {
    observeBoldOptions();
  }
})();